export function scrollToElement({
  container: parent,
  element: child,
  direction = 'vertical',
  behavior = 'instant',
  offset = 8,
  block = 'nearest',
}: {
  container: HTMLElement;
  element: HTMLElement;
  direction?: 'vertical' | 'horizontal';
  offset?: number;
  behavior?: 'smooth' | 'instant';
  block?: 'nearest' | 'center';
}) {
  const boxParent = parent.getBoundingClientRect();
  const boxChild = child.getBoundingClientRect();

  const top = (() => {
    if (direction !== 'vertical') return;

    if (block === 'center') {
      const elementTop = boxChild.top - boxParent.top + parent.scrollTop;
      return elementTop - boxParent.height / 2 + boxChild.height / 2;
    }

    // нужно проскроллить вниз
    if (boxParent.bottom <= boxChild.bottom) {
      return parent.scrollTop + boxChild.bottom - boxParent.bottom + offset;
    }
    // нужно проскроллить вверх
    else if (boxParent.top >= boxChild.top) {
      return parent.scrollTop + boxChild.top - boxParent.top - offset;
    }
  })();

  const left = (() => {
    if (direction !== 'horizontal') return;

    if (block === 'center') {
      const elementLeft = boxChild.left - boxParent.left + parent.scrollLeft;
      return elementLeft - boxParent.width / 2 + boxChild.width / 2;
    }

    // нужно проскроллить вправо
    if (boxParent.right <= boxChild.right) {
      return parent.scrollLeft + boxChild.right - boxParent.right + offset;
    }
    // нужно проскроллить влево
    else if (boxParent.left >= boxChild.left) {
      return parent.scrollLeft + boxChild.left - boxParent.left - offset;
    }
  })();

  if (left !== undefined || top !== undefined) {
    parent.scrollTo({ top, left, behavior });
  }
}
